import { Observable, tap } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginValidateRequest, LoginValidateResponse } from '@models/user/login-validate.model';
import { LoginRequest, LoginResponse } from '@models/user/login.model';
import {
    PasswordRequestRequest, PasswordRequestResponse
} from '@models/user/password-request.model';
import { PasswordResetRequest } from '@models/user/password-reset.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) {}

  validateLogin(request: LoginValidateRequest): Observable<LoginValidateResponse> {
    return this.httpClient.post<LoginValidateResponse>('user/login/validate', request);
  }

  login(request: LoginRequest): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>('user/login', request).pipe(
      tap(response => {
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('user.id', response.user.id.toString());
        localStorage.setItem('user.username', response.user.username);
        localStorage.setItem('user.name', response.user.name);
      })
    );
  }

  requestPassword(request: PasswordRequestRequest): Observable<PasswordRequestResponse> {
    return this.httpClient.post<PasswordRequestResponse>('user/password/request', request);
  }

  resetPassword(request: PasswordResetRequest): Observable<any[]> {
    return this.httpClient.post<any[]>('user/password/reset', request);
  }

  logout(): Observable<any[]> {
    return this.httpClient.post<any[]>('user/logout', null).pipe(
      tap(() => {
        this.removeUserLocalStorageData();
        // @ts-ignore
        if (window?.accessTokenExpired) {
          // @ts-ignore
          window?.accessTokenExpired?.postMessage('');
        }
        // @ts-ignore
        if (window?.flutter_inappwebview) {
          // @ts-ignore
          window?.flutter_inappwebview?.callHandler('accessTokenExpired');
        }
        this.router.navigate(['/auth/login']);
      })
    );
  }

  removeUserLocalStorageData() {
    localStorage.removeItem('access_token');
    // localStorage.removeItem('user.id');
    // localStorage.removeItem('user.username');
    // localStorage.removeItem('user.name');
  }
}
